/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Empty_TextInputs */



/**
* | output |
* | --- |
* | "Remove blank events" |
*
* @param {Qc_Fix_Empty_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_empty_text = /** @type {((inputs?: Qc_Fix_Empty_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Empty_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les événements vides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Events entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi eventi vuoti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить пустые события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar eventos vacíos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除空白事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空のイベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली इवेंट हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover eventos vazios")
	return /** @type {LocalizedString} */ ("Remove blank events")
});